import isNil from "./isNil";

/**
 * Returns true if the value is not null or undefined.
 **/
export default function isPresent<T>(value: T): value is NonNullable<T> {
  return !isNil(value);
}
